/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Deductible } from './deductible';
import { FullyComprehensiveInsurance } from './fullyComprehensiveInsurance';
import { DriverProtection } from './driverProtection';
import { NcdClass } from './ncdClass';
import { SpecialEquipmentAmount } from './specialEquipmentAmount';
import { BBB } from './bBB';
import { Price } from './price';
import { GAP } from './gAP';
import { MotorVehicleLiabilityInsurance } from './motorVehicleLiabilityInsurance';
import { NcdClassReason } from './ncdClassReason';
import { PartialComprehensiveInsurance } from './partialComprehensiveInsurance';
import { RoadsideAssistance } from './roadsideAssistance';

/**
 * @type MotorVehicleElementaryProduct
 * @export
 */
export type MotorVehicleElementaryProduct =
  | BBB
  | DriverProtection
  | FullyComprehensiveInsurance
  | GAP
  | MotorVehicleLiabilityInsurance
  | PartialComprehensiveInsurance
  | RoadsideAssistance;
